import { render, staticRenderFns } from "./SelectorStrings.vue?vue&type=template&id=b4012fa6&"
import script from "./SelectorStrings.vue?vue&type=script&lang=js&"
export * from "./SelectorStrings.vue?vue&type=script&lang=js&"
import style0 from "./SelectorStrings.vue?vue&type=style&index=0&id=b4012fa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports